import { Component, input, output, signal, effect, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-modal-popup',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal-popup.html',
  styleUrl: './modal-popup.scss',
})
export class ModalPopup {
  title = input<string>('');
  message = input<string>('');
  icon = input<string>('fa-solid fa-plus');
  /** Image icon (e.g. a public/img/*.svg path) — takes precedence over `icon` when set. */
  iconSrc = input<string>('');
  size = input<'sm' | 'md' | 'lg' | 'med'>('md');
  isOpen = input<boolean>(false);
  showFooter = input<boolean>(true);
  rtl = input<boolean | undefined>(undefined);
  cancelLabel = input<string>('Cancel');
  confirmLabel = input<string>('Confirm');
  confirmDisabled = input<boolean>(false);

  // Output Events
  confirm = output<void>();
  cancel = output<void>();
  close = output<void>();

  // Animation active state
  visible = signal<boolean>(false);

  isRtl = computed(() => {
    const userRtl = this.rtl();
    if (userRtl !== undefined) {
      return userRtl;
    }
    const htmlDir = document.documentElement.getAttribute('dir');
    const bodyDir = document.body.getAttribute('dir');
    return htmlDir === 'rtl' || bodyDir === 'rtl';
  });

  constructor() {
    effect(() => {
      if (this.isOpen()) {
        this.visible.set(true);
      } else {
        // Wait for scale-down animation to complete (250ms)
        setTimeout(() => {
          if (!this.isOpen()) {
            this.visible.set(false);
          }
        }, 250);
      }
    });
  }

  onCloseClick() {
    this.close.emit();
  }

  onCancelClick() {
    this.cancel.emit();
  }

  onConfirmClick() {
    this.confirm.emit();
  }
}
